/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { AlertContainer } from 'react-bs-notifier'
import { Remove, IAlert } from 'redux-app/types/alerts'
import Alert from './apps/Alert'

interface IProps {
  alerts: IAlert[],
  remove: Remove,
}

const Alerts: React.SFC<IProps> = ({
  alerts,
  remove,
}) => (
  <AlertContainer>
    {alerts.map(item => (
      <Alert
        key={item.id}
        {...item}
        onDismiss={remove}
      />
    ))}
  </AlertContainer>
)

export default Alerts
